import { registerSchema } from '@erikdakoda/utils/schemaRegistry';
import { CleanupTranscriptSchema } from '../types';

/**
 * Registers the cleanup-transcript structured-output schema used by Bot.handle
 * `transcribe-cleanup`. Idempotent; safe to call from app `initPackages`.
 */
export function seedCleanupTranscriptSchema(): void {
  registerSchema({
    app: 'uvilo-ai',
    name: 'cleanup-transcript',
    version: 1,
    zodSchema: CleanupTranscriptSchema,
    format: {},
  });
}
